import { Stack, ProgressIndicator, Container } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { RoutingRulesFormStepName } from '../../types';
import { useRoutingRuleFormStepContext } from '../../contexts';
import { ItemsAndConditionsFields } from './steps/itemsAndConditions/ItemsAndConditionsFields';
import { RoutingRuleFormTimingFields } from './steps/timing';
import { TargetBillFields } from './steps/targetBill/TargetBillFields';
import { RoutingRuleSummary } from './steps/summary/RoutingRuleSummary';

const matchStep = (currentStep: RoutingRulesFormStepName) => {
    switch (currentStep) {
        case RoutingRulesFormStepName.Timing:
            return <RoutingRuleFormTimingFields />;
        case RoutingRulesFormStepName.ItemsAndConditions:
            return <ItemsAndConditionsFields />;
        case RoutingRulesFormStepName.TargetBill:
            return <TargetBillFields />;
        case RoutingRulesFormStepName.Summary:
            return <RoutingRuleSummary />;
    }
};

const getFormSteps = (completedSteps: RoutingRulesFormStepName[]) => [
    {
        value: RoutingRulesFormStepName.Timing,
        label: lt(TextKey.RoutingRulesFormStepNameTiming),
        completed: completedSteps.includes(RoutingRulesFormStepName.Timing),
        editable: true,
    },
    {
        value: RoutingRulesFormStepName.ItemsAndConditions,
        label: lt(TextKey.RoutingRulesFormStepNameItemsAndConditions),
        completed: completedSteps.includes(RoutingRulesFormStepName.ItemsAndConditions),
        editable: completedSteps.includes(RoutingRulesFormStepName.Timing),
    },
    {
        value: RoutingRulesFormStepName.TargetBill,
        label: lt(TextKey.RoutingRulesFormStepNameTargetBill),
        completed: completedSteps.includes(RoutingRulesFormStepName.TargetBill),
        editable: completedSteps.includes(RoutingRulesFormStepName.ItemsAndConditions),
    },
    {
        value: RoutingRulesFormStepName.Summary,
        label: lt(TextKey.RoutingRulesFormStepNameSummary),
        completed: false,
        editable: completedSteps.includes(RoutingRulesFormStepName.TargetBill),
    },
];

export const RoutingRuleFormContent = ({
    onStepChange,
}: {
    onStepChange: (step: RoutingRulesFormStepName) => void;
}) => {
    const { currentStep, completedSteps } = useRoutingRuleFormStepContext();
    const formSteps = getFormSteps(completedSteps);

    return (
        <Stack vertical itemAlignment="center" spacing="400">
            <Container maxWidth="1000px" width="100%">
                <ProgressIndicator
                    steps={formSteps}
                    activeStep={currentStep}
                    onStepChange={(step) => {
                        onStepChange(step);
                    }}
                />
            </Container>
            <Container maxWidth="640px" width="100%">
                <Stack vertical spacing="300" fill>
                    {matchStep(currentStep)}
                </Stack>
            </Container>
        </Stack>
    );
};
